module.exports = __webpack_public_path__ + "static/img/98025D_R_2_3_20180406_LC.13da79a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/98025D_R_2_3_20180406_LC.png
// module id = 4Ts1
// module chunks = 0